module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "pgemnt-4"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('div', {
    staticClass: "titleH"
  }, [_vm._v("汇总表")]), _vm._v(" "), _c('div', {
    staticClass: "seekArea",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.initBase()
      }
    }
  }, [_vm._v("初始化基本信息")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.initFinance()
      }
    }
  }, [_vm._v("初始化经营情况")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.initPublication()
      }
    }
  }, [_vm._v("初始化出版物")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.initWorker()
      }
    }
  }, [_vm._v("初始化人员")])], 1), _vm._v(" "), _c('div', {
    staticClass: "seekArea",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.initLxdzBase()
      }
    }
  }, [_vm._v("连续型-初始化单位信息")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.initLxdzFinance()
      }
    }
  }, [_vm._v("连续型-初始化经营情况")])], 1), _vm._v(" "), _c('div', {
    staticClass: "seekArea",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.batchAuditGen()
      }
    }
  }, [_vm._v("审核判断数据生成")])], 1), _vm._v(" "), _c('div', {
    staticClass: "seekArea",
    staticStyle: {
      "margin-bottom": "10px"
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ttBar"
  }, [_c('span', [_vm._v("统计数据生成")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c1566cf4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pgment/sectStatic.vue
// module id = 1796
// module chunks = 1